(function () {
  function moneyFormat(cents) {
    try {
      return Shopify.formatMoney(cents, Shopify.money_format);
    } catch {
      return "$" + (cents / 100).toFixed(2);
    }
  }

  function getProductForm(root) {
    const id = root.dataset.formId && document.getElementById(root.dataset.formId);
    if (id) return id;
    const section = root.closest('[id^="shopify-section-"]') || document;
    const forms = Array.from(section.querySelectorAll('form[action^="/cart/add"]'));
    return forms.find((f) => f.querySelector('input[name="id"], select[name="id"]')) || forms[0] || null;
  }

  function setPurchaseUIState(form, available) {
    if (!form) return;

    const atc =
      form.querySelector('button[name="add"]') ||
      form.querySelector('button[type="submit"]') ||
      form.querySelector(".product-form__submit");

    if (atc) {
      if (available) {
        atc.disabled = false;
        atc.removeAttribute("aria-disabled");
        atc.classList.remove("disabled");
        atc.style.display = "";
      } else {
        atc.disabled = true;
        atc.setAttribute("aria-disabled", "true");
        atc.classList.add("disabled");

        atc.style.display = "none";
      }
    }

    const notify =
      form.querySelector('[data-bis-trigger]') ||
      form.querySelector(".klaviyo-bis-trigger") ||
      form.querySelector(".back-in-stock-snippet") ||
      form.querySelector(".back-in-stock") ||
      form.querySelector(".notify-me") ||
      form.querySelector('[data-notify-me]') ||
      form.querySelector('[data-notify]') ||
      form.querySelector("#BIS_trigger") ||
      form.querySelector('[id*="BIS_trigger"]') ||

      document.querySelector('[data-bis-trigger]') ||
      document.querySelector(".klaviyo-bis-trigger") ||
      document.querySelector(".back-in-stock-snippet") ||
      document.querySelector(".back-in-stock") ||
      document.querySelector(".notify-me") ||
      document.querySelector('[data-notify-me]') ||
      document.querySelector('[data-notify]') ||
      document.querySelector("#BIS_trigger") ||
      document.querySelector('[id*="BIS_trigger"]');

    if (notify) {
      notify.style.display = available ? "none" : "";
      notify.setAttribute("aria-hidden", available ? "true" : "false");
    }
  }

  function forceFormVariantId(form, variantId, variantObj) {
    if (!form) return;

    const fields = form.querySelectorAll('input[name="id"], select[name="id"]');
    fields.forEach((el) => {
      if (el.tagName === "SELECT") {
        let opt = Array.from(el.options).find((o) => Number(o.value) === Number(variantId));
        if (!opt) {
          opt = new Option(variantId, variantId, true, true);
          el.add(opt);
        }
        el.value = String(variantId);
      } else {
        el.value = String(variantId);
      }
      el.removeAttribute("disabled");
      el.dispatchEvent(new Event("input", { bubbles: true }));
      el.dispatchEvent(new Event("change", { bubbles: true }));
    });

    const buttons = form.querySelectorAll('button, [type="submit"], .product-form__submit');
    buttons.forEach((btn) => {
      btn.dataset.variantId = String(variantId);
      btn.dataset.variant = String(variantId);
      btn.dataset.productVariantId = String(variantId);
    });

    form.dispatchEvent(new Event("change", { bubbles: true }));
    form.dispatchEvent(new CustomEvent("variant:change", { bubbles: true, detail: { variant: variantObj } }));
    form.dispatchEvent(new CustomEvent("variantChange", { bubbles: true, detail: { variant: variantObj } }));

    if (history.replaceState) {
      const url = new URL(location.href);
      url.searchParams.set("variant", variantId);
      history.replaceState({}, "", url.toString());
    }
  }

  function updatePriceUI(root, variant) {
    const priceEl = root.querySelector("[data-vht-price]");
    const compEl = root.querySelector("[data-vht-compare]");
    if (!priceEl || !variant) return;

    priceEl.textContent = moneyFormat(variant.price);
    const ca = variant.compare_at_price;
    if (compEl) {
      if (ca && ca > variant.price) {
        compEl.textContent = moneyFormat(ca);
        compEl.classList.remove("is-hidden");
      } else {
        compEl.textContent = "";
        compEl.classList.add("is-hidden");
      }
    }
  }

  function setDiffVisibility(root, show) {
    const chip = root.querySelector("[data-vht-diff]");
    if (!chip) return;

    const diffCents = Number(chip.dataset.diffCents || 0);
    if (show && diffCents !== 0) {
      const sign = diffCents > 0 ? "+" : "−";
      chip.textContent = sign + moneyFormat(Math.abs(diffCents));
      chip.classList.remove("is-hidden");
    } else {
      chip.classList.add("is-hidden");
      chip.textContent = "";
    }
  }

  function setToggleDisabled(btn, disabled) {
    if (!btn) return;
    btn.disabled = !!disabled;
    btn.classList.toggle("vht-disabled", !!disabled);
  }

  function swapThumb(root, imgSrc) {
    const thumb = root.querySelector("[data-vht-thumb]");
    if (thumb && imgSrc) thumb.src = imgSrc;
  }

  function mount(root) {
    if (!root || root.dataset.vhtMounted === "true") return;

    const toggleBtn = root.querySelector("[data-vht-toggle]");
    const labelEl = root.querySelector("[data-vht-variant-label]");
    if (!toggleBtn || !labelEl) {
      root.dataset.vhtMounted = "true";
      return;
    }

    const onId = Number(root.dataset.onVariantId);
    const offId = Number(root.dataset.offVariantId);
    const onTitle = root.dataset.onTitle;
    const offTitle = root.dataset.offTitle;
    const productId = root.dataset.productId;
    const offImg = root.dataset.offImg;
    const onImg = root.dataset.onImg;

    let productJson = null;
    const jsonEl =
      document.querySelector(`script[type="application/json"][data-product-id="${productId}"]`) ||
      document.getElementById(`ProductJson-${productId}`);

    if (jsonEl) {
      try {
        productJson = JSON.parse(jsonEl.textContent.trim());
      } catch (e) {}
    }

    const getVariant = (id) => productJson?.variants?.find((v) => Number(v.id) === Number(id));

    const computeAvailable = (which, id) => {
      const key = which === "on" ? "onAvailable" : "offAvailable";

      if (root.dataset[key] !== undefined) {
        return root.dataset[key] === "true";
      }

      const v = getVariant(id);
      if (v && typeof v.available !== "undefined") return !!v.available;

      return true;
    };

    const onAvailable = computeAvailable("on", onId);
    const offAvailable = computeAvailable("off", offId);

    setToggleDisabled(toggleBtn, onAvailable === false);

    const startOn = !offAvailable && onAvailable;

    root.dataset.currentVariantId = String(startOn ? onId : offId);

    toggleBtn.setAttribute("aria-checked", String(startOn));
    labelEl.textContent = startOn ? onTitle : offTitle;
    setDiffVisibility(root, startOn);

    const form = getProductForm(root);
    const startVariantId = startOn ? onId : offId;
    const startVariantObj = getVariant(startVariantId);

    forceFormVariantId(form, startVariantId, startVariantObj);
    updatePriceUI(root, startVariantObj);
    swapThumb(root, startOn ? onImg : offImg);

    setPurchaseUIState(form, startOn ? onAvailable : offAvailable);

    if (form) {
      const sync = (ev) => {
        if (ev && (ev.target.closest("[data-vht-toggle]") || ev.target.closest('[data-component="vht"]')))
          return;
        const currentId = Number(root.dataset.currentVariantId);
        forceFormVariantId(form, currentId, getVariant(currentId));
      };

      form.addEventListener("submit", sync, true);

      const submitters = form.querySelectorAll('button[type="submit"], [name="add"], .product-form__submit');
      submitters.forEach((btn) => {
        btn.addEventListener("pointerdown", sync, { capture: true });
        btn.addEventListener("click", sync, { capture: true });
      });
    }

    toggleBtn.addEventListener("click", () => {
      const canGoOn = onAvailable !== false;

      const goingOn = toggleBtn.getAttribute("aria-checked") !== "true";
      if (goingOn && !canGoOn) return;

      toggleBtn.setAttribute("aria-checked", String(goingOn));

      const id = goingOn ? onId : offId;
      const title = goingOn ? onTitle : offTitle;

      root.dataset.currentVariantId = String(id);
      labelEl.textContent = title;
      setDiffVisibility(root, goingOn);

      const f = getProductForm(root);
      const v = getVariant(id);

      forceFormVariantId(f, id, v);
      updatePriceUI(root, v);
      swapThumb(root, goingOn ? onImg : offImg);

      setPurchaseUIState(f, goingOn ? onAvailable : offAvailable);
    });

    root.dataset.vhtMounted = "true";
  }

  function mountAll() {
    document.querySelectorAll('[data-component="vht"]').forEach(mount);
  }

  document.addEventListener("DOMContentLoaded", mountAll);
  window.addEventListener("pageshow", mountAll);
  document.addEventListener("shopify:section:load", mountAll);
  document.addEventListener("shopify:section:select", mountAll);
  document.addEventListener("shopify:section:reorder", mountAll);

  document.addEventListener("turbo:load", mountAll);
  document.addEventListener("page:load", mountAll);
  document.addEventListener("swup:contentReplaced", mountAll);
  document.addEventListener("barba:after", mountAll);

  const mo = new MutationObserver(() => mountAll());
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();